import { IntentType } from '@40seas/entities/intents';
import { AddContactModalStrategyProvider } from './addContactModalStrategyProvider';
import { DashboardStrategyProvider } from './dashboardStrategyProvider';
import { GenericModalStrategyProvider } from './genericModalStrategyProvider';
import { GuestPortalStrategyProvider } from './guestPortalStrategyProvider';
import { LayoutStrategyProvider, LayoutStrategyProviderParams } from './layoutStrategyProvider';
import { RedirectStrategyProvider } from './redirectStrategyProvider';
import { SignupModalStrategyProvider } from './signupModalStrategyProvider';

export class LayoutStrategyManager {
    strategies: LayoutStrategyProvider[];

    constructor(params: LayoutStrategyProviderParams) {
        this.strategies = [
            new RedirectStrategyProvider(params),
            new GuestPortalStrategyProvider(params),
            new GenericModalStrategyProvider(params),
            new SignupModalStrategyProvider(params),
            new AddContactModalStrategyProvider(params),
            new DashboardStrategyProvider(params),
        ];
    }

    getStrategy = (): LayoutStrategyProvider => {
        for (const strategy of this.strategies) {
            if (strategy.shouldApply()) {
                return strategy;
            }
        }

        throw new Error('Unknown state');
    };
}

export function convertStringToEnumValue(stringValue: string): IntentType | undefined {
    const enumValues = Object.values(IntentType);
    const enumValue = enumValues.find((enumValue) => enumValue === stringValue);
    return enumValue;
}
